<style lang="scss" scoped>
@import './login.scss';
.login-log-container {
  padding: 32px 35px 15px 35px;
}
</style>
<style lang="scss">
.log-body {
  .el-input {
    .el-input__inner {
      height: 38px;
    }
  }
}
</style>
<template>
  <div>
    <div
      class="log-body"
      :style="{
        backgroundImage: 'url(' + login_bg + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }"
    >
      <div class="log-container">
        <el-form
          ref="ruleForm1"
          :model="ruleForm1"
          :rules="rules1"
          label-position="left"
          label-width="0px"
          class="login-log-container"
        >
          <div class="title">
            云店新零售系统登录
          </div>
          <!-- dev login -->
          <div v-if="showPhoneLogin">
            <el-form-item prop="account">
              <el-input
                v-model="ruleForm1.account"
                type="text"
                name="account"
                auto-complete="off"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input
                v-model="ruleForm1.checkPass"
                type="password"
                name="password"
                auto-complete="off"
                placeholder="密码"
              />
            </el-form-item>
            <el-form-item class="log-opr clearfix">
              <el-checkbox
                v-model="checked"
                checked
                class="remember f_l"
              >
                记住密码
              </el-checkbox>
            </el-form-item>
          </div>
          <el-form-item style="width: 100%">
            <!-- dev login -->
            <div v-if="showPhoneLogin">
              <el-button
                type="primary"
                style="
                  width: 200px;
                  margin: 0 auto;
                  display: block;
                  height: 40px;
                  background-color: #3276d5;
                "
                :loading="logining"
                :disabled="submitDisabled"
                @click.native.prevent="handleSubmit1"
              >
                登录
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import loginMixin from './loginMixin'
export default {
  mixins: [loginMixin],
  data () {
    const showPhoneLogin =
      process.env.VUE_APP_STATUS == 'dev' ||
      process.env.VUE_APP_STATUS == 'uat' ||
      location.host == 'jd.yuanyuanke.cn'
    return {
      showPhoneLogin
    }
  }
}
</script>
